import React, {useEffect, useState} from 'react';
import { Form, Input, Button, message} from 'antd';
import axios from 'axios';

// 设置 Axios 的全局 baseURL
axios.defaults.baseURL = 'https://cybersphereinstitute.xyz';

const CreateWallet = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        message.config({
            duration: 3,  // 消息显示时间（秒）
            maxCount: 3,  // 最大同时显示数量
        });
    }, []);

    // 表单提交处理
    const onFinish = async (values) => {
        setLoading(true);

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/v1/wallet/create', {
                name: values.name,
                count: parseInt(values.count, 10), // 确保 count 是整数
                chain_type: 'evm',
            },
                {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data.code === 0) {
                message.success('创建成功！');
            } else {
                handleError(response.data.code, response.data.msg);
            }
        } catch (error) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };

    // 错误码处理
    const handleError = (code, msg) => {
        switch (code) {
            case 2001:
                message.error('创建失败：钱包组名称已存在');
                break;
            case 2002:
                message.error('创建失败：钱包数量超出范围');
                break;
            default:
                if (typeof msg === 'string') {
                    console.log(msg);
                    message.error(msg);  // 仅用于测试
                    // message.destroy();  // 清除之前的消息
                    // message.error('error');
                } else {
                    message.error('未知错误');
                }
                break;
        }
    };

    return (
        <Form
            layout="vertical"
            onFinish={onFinish}
            style={{ maxWidth: 400, margin: 'auto', marginTop: 50 }}
        >
            <Form.Item
                label="钱包组名称"
                name="name"
                rules={[
                    { required: true, message: '请输入钱包组名称' },
                    { max: 50, message: '钱包组名称不能超过50个字符' },
                ]}
            >
                <Input placeholder="请输入钱包组名称" />
            </Form.Item>

            <Form.Item
                label="钱包数量"
                name="count"
                rules={[
                    {
                        required: true,
                        message: '请输入钱包数量',
                    },
                    {
                        type: 'number',
                        validator: (_, value) =>
                            value > 1 && value <= 1000
                                ? Promise.resolve()
                                : Promise.reject(new Error('钱包数量必须在2到1000之间')),
                    },
                ]}
            >
                <Input
                    placeholder="请输入钱包数量"
                    type="number"
                    onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault(); // 阻止非数字输入
                        }
                    }}
                />
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading} block>
                    创建
                </Button>
            </Form.Item>
        </Form>
    );
};

export default CreateWallet;
